export default __webpack_public_path__ + "static/media/no-image.3bc771d3.svg";